// import { useNavigate, useLocation } from "react-router-dom";
// import "./BottomNav.css";

// /*  Centralised nav config  */
// const navItems = [
//   { icon: "hammer", label: "My Bids",  path: "/bids"      },
//   { icon: "doc",    label: "Passbook", path: "/passbook"  },
//   { icon: "home",   label: "Home",     path: "/home",  main: true },
//   { icon: "bank",   label: "Funds",    path: "/funds"     },
//   { icon: "chat",   label: "Support",  path: "/support"   },
// ];

// export default function BottomNav() {
//   const navigate  = useNavigate();
//   const { pathname } = useLocation();     // current URL – to highlight “active”

//   return (
//     <nav className="bottom-nav">
//       {navItems.map(({ icon, label, path, main }) => {
//         const isActive = pathname.startsWith(path);
//         return (
//           <button
//             key={label}
//             className={`nav-item ${isActive ? "active" : ""} ${main ? "main" : ""}`}
//             onClick={() => navigate(path)}
//           >
//             <span className={`icon-${icon}`} />
//             {/* Hide label under the yellow circle; show for others */}
//             {!main && <span>{label}</span>}
//           </button>
//         );
//       })}
//     </nav>
//   );
// }


import { useNavigate, useLocation } from "react-router-dom";
import "./BottomNav.css";
import { useContext } from "react";
import { AppContext } from "../context/AppContext"; 

// CAUTION: Replace this with your actual support phone number, including the country code.
//const WHATSAPP_SUPPORT_NUMBER = "919876543210"; // Example for an Indian number

/* Centralised nav config  */
const navItems = [
  { icon: "hammer", label: "My Bids",  path: "/bids"      },
  { icon: "doc",    label: "Passbook", path: "/passbook"  },
  { icon: "home",   label: "Home",     path: "/home",  main: true },
  { icon: "bank",   label: "Funds",    path: "/funds"     },
  { icon: "chat",   label: "Support",  path: "/support"   }, // Path is now just an identifier
];

export default function BottomNav({whatsappNumber} ) {
  const navigate   = useNavigate();
  const { pathname } = useLocation();    // current URL – to highlight “active”
    const { user, isInactive } = useContext(AppContext);
    const visibleNavItems = isInactive
    ? [
        { icon: "hammer", label: "My Bids",       path: "/bids"      },
        { icon: "doc",    label: "Bid History",   path: "/passbook"  },
        { icon: "home",   label: "Home",          path: "/home",  main: true },
        { isCoins: true,  icon: "coin-tab",       label: "Coins", path: "/passbook" },
        { icon: "chat",   label: "Support",       path: "/support"   },
      ]
    : (user?.accountStatus === true ? navItems : navItems.filter(item => item.label === "Home"));
  return (
    <nav className="bottom-nav">
      {visibleNavItems.map((item) => {
        const { icon, label, path, main, isCoins } = item;
        const isActive = pathname.startsWith(path);
        return (
          <button
            key={label}
            className={`nav-item ${isActive ? "active" : ""} ${main ? "main" : ""}`}
            // --- THIS is the only part that has changed ---
            onClick={() => {
              if (label === "Support") {
                // If the button is "Support", open the WhatsApp link
                window.open(`https://wa.me/${ whatsappNumber }`, '_blank', 'noopener,noreferrer');
              } else {
                // For all other buttons, navigate normally
                navigate(path);
              }
            }}
          >
            {main ? (
               <span className={`icon-${icon}`} />
            ) : isCoins ? (
              <span style={{ fontSize: "22px", height: "22px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>🪙</span>
            ) : (
              <span className={`icon-${icon}`} />
            )}
            {!main && (
              <span style={isCoins ? { fontSize: "13px", fontWeight: "600" } : {}}>
                {label}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
